/** Tiempo máximo (segundos) para que el usuario conceda permisos de cámara y micrófono antes de KO. */
export const PERMISSIONS_MAX_SECONDS = 300;
